module.exports = __webpack_public_path__ + "static/media/cat_sit.415c3b76.svg";